import { ResourceOperations, ResourceTypes } from '../../../authentication/resources';
import { useIsAllowed } from '../../../authentication/use-is-allowed';

export function useCanReadCitizenDialog(): boolean {
  return useIsAllowed([{ resourceType: ResourceTypes.CitizenDialog, resourceOperation: ResourceOperations.Read }]);
}

export function useCanWriteCitizenDialog(): boolean {
  return useIsAllowed([{ resourceType: ResourceTypes.CitizenDialog, resourceOperation: ResourceOperations.Write }]);
}
